import {
  Form,
  InputNumber,
  Select,
  Button,
  Input,
  notification,
  Divider,
  Card,
  Tag,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import WebUtils from "../../../utils/WebUtils";
import {
  getGenerateInterviewSkills,
  postBlueprintCreateNew,
  postUpdateIDronaConfig,
} from "../../../api/candidate";
import { Trash2 } from "lucide-react";

const { Option } = Select;
const { TextArea } = Input;

function SelectedBlueprintForm({
  selectedAutoFillData,
  setSteps,
  setLoading,
  jdDetails,
  userDetail,
  jdId,
  disableEdit,
  setDisableEdit,
  iDronaConfigFlag,
  noBackButton,
  iDronaId,
}) {
  const [form] = Form.useForm();

  const [skills, setSkills] = useState([]);
  const [subInput, setSubInput] = useState("");
  const [interviewDuration, setInterviewDuration] = useState(
    form.getFieldValue("interviewDuration") ||
      selectedAutoFillData?.blueprintVariables?.interviewDuration / 60 ||
      0
  );

  const handleSubInputChange = (skillIndex, value) => {
    setSubInput((prev) => ({
      ...prev,
      [skillIndex]: value, // update only this skill's input
    }));
  };

  const handleAddSubSkill = (skillIndex) => {
    if (!subInput[skillIndex]) return;

    addSubSkill(skillIndex, subInput[skillIndex]);
    setSubInput((prev) => ({
      ...prev,
      [skillIndex]: "", // clear only this skill input
    }));
  };

  let totalWeightageFinal = 0;

  function convertSecondsToMinutes(seconds) {
    if (typeof seconds !== "number" || seconds < 0) {
      //   throw new Error("Input must be a non-negative number.");
      return;
    }
    const minutes = Math.ceil(seconds / 60);
    return minutes;
  }
  const addSkill = () => {
    setSkills([
      ...skills,
      { skillName: "", skillWeightage: "", subSkills: [] },
    ]);
  };

  const removeSkill = (index) => {
    const newSkills = [...skills];
    newSkills.splice(index, 1);
    setSkills(newSkills);
  };

  const updateSkill = (index, field, value) => {
    const newSkills = [...skills];
    newSkills[index][field] = value;
    setSkills(newSkills);
  };

  const addSubSkill = (skillIndex, value) => {
    if (!value) return;
    const newSkills = [...skills];
    newSkills[skillIndex].subSkills.push({ areaOfProbing: value });
    // console.log(newSkills);
    setSkills(newSkills);
  };

  const removeSubSkill = (skillIndex, subIndex) => {
    const newSkills = [...skills];
    newSkills[skillIndex].subSkills.splice(subIndex, 1);
    setSkills(newSkills);
  };

  const generateSkills = (values) => {
    const url = `${getGenerateInterviewSkills}?jdIdentifier=${jdId}`;

    setLoading(true);
    // console.log(reqBody);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setSkills(result.data.data);
        } else {
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const handleSubmit = (values) => {
    const url = `${postBlueprintCreateNew}?jdIdentifier=${jdId}&userIdentifier=${
      userDetail?.userIdentifier || null
    }&blueprintId=${selectedAutoFillData?.blueprintId}&blueprintName=${
      selectedAutoFillData?.blueprintName
    }&blueprintType=${selectedAutoFillData?.blueprintType}`;

    const selectedUserLangCode = values.userLanguage; // e.g., "en-IN"
    const selectedBotLangCode = values.botLanguage; // e.g., "hi"

    // Find the full language objects
    const userLanguageObj = jdDetails?.allowedUserLanguages.find(
      (lang) => lang.languageCode === selectedUserLangCode
    );

    const botLanguageObj = jdDetails?.allowedBotLanguages.find(
      (lang) => lang.languageCode === selectedBotLangCode
    );

    let reqBody = {
      jobTitle: values.jobTitle,
      company: values.company,
      yearsOfExperience: values.yearsOfExperience,
      jobResponsibilities: values.jobResponsibilities,
      jobRequirements: values.jobRequirements,
      userLanguage: userLanguageObj,
      botLanguage: botLanguageObj,
      interviewDuration: values.interviewDuration * 60,
      // expiryDate: selectedAutoFillData.expiryDate,
      skillsList: skills || [],
    };

    setLoading(true);
    // console.log(reqBody);

    WebUtils.httpOperations(url, reqBody, "POST")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          console.log(result.data.data);
          notification.success({
            message: "Success",
            description: `${"New Mock Interview Created "}`,
            placement: "topRight",
            showProgress: true,
            duration: 2,
          });
          setTimeout(() => {
            window.location.href = `/schedule-mock-interview?jdIdentifier=${jdId}&iDronaId=${result.data?.data}`;
          }, 2000);
        } else {
          notification.error({
            message: "Failed",
            description: `${"Mock Interview Creation Failed! "}`,
            placement: "topRight",
            showProgress: true,
            duration: 2,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const handleConfigSubmit = (values) => {
    const url = `${postUpdateIDronaConfig}`;

    const selectedUserLangCode = values.userLanguage; // e.g., "en-IN"
    const selectedBotLangCode = values.botLanguage; // e.g., "hi"

    // Find the full language objects
    const userLanguageObj = jdDetails?.allowedUserLanguages.find(
      (lang) => lang.languageCode === selectedUserLangCode
    );

    const botLanguageObj = jdDetails?.allowedBotLanguages.find(
      (lang) => lang.languageCode === selectedBotLangCode
    );

    let reqBody = {
      idronaIdentifier: iDronaId,
      userIdentifier: userDetail?.userIdentifier,
      blueprintId: selectedAutoFillData?.blueprintId,
      blueprintName: selectedAutoFillData?.blueprintName,
      blueprintType: selectedAutoFillData?.blueprintType,
      blueprintVariableData: {
        jobTitle: values.jobTitle,
        company: values.company,
        yearsOfExperience: values.yearsOfExperience,
        jobResponsibilities: values.jobResponsibilities,
        jobRequirements: values.jobRequirements,
        userLanguage: userLanguageObj,
        botLanguage: botLanguageObj,
        interviewDuration: values.interviewDuration * 60,
        // expiryDate: selectedAutoFillData.expiryDate,
        skillsList: skills || [],
      },
    };

    setLoading(true);
    // console.log(reqBody);

    WebUtils.httpOperations(url, reqBody, "POST")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setDisableEdit(true);
          notification.success({
            message: "Success",
            description: `${"iDrona Configuration updated! "}`,
            placement: "topRight",
            showProgress: true,
            duration: 2,
          });
        } else {
          notification.error({
            message: "Failed",
            description: `${"Update Failed! "}`,
            placement: "topRight",
            showProgress: true,
            duration: 2,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const validateSkills = (skills) => {
    for (let i = 0; i < skills?.length; i++) {
      const skill = skills[i];

      // Check for empty skill name
      if (!skill?.skillName || skill?.skillName.trim() === "") {
        return `Please enter a name for Skill ${i + 1}.`;
      }

      // Check for empty or invalid weightage
      if (
        skill?.skillWeightage === undefined ||
        skill?.skillWeightage === null ||
        skill?.skillWeightage <= 0
      ) {
        return `Please enter a weightage for Skill ${i + 1}.`;
      }
    }

    // All skills are valid
    return null;
  };
  const onFinish = (values) => {
    console.log("Form Data:", values, totalWeightageFinal);
    if (totalWeightageFinal > 100) {
      message.error("Total weightage must be 100 or less!");
    } else if (validateSkills(skills)) {
      message.error(validateSkills(skills));
    } else {
      if (iDronaConfigFlag) {
        handleConfigSubmit(values);
      } else {
        handleSubmit(values);
      }
    }
  };

  useEffect(() => {
    setSkills(selectedAutoFillData?.blueprintVariables?.skillsList || []);

    form.setFieldsValue({
      interviewDuration: convertSecondsToMinutes(
        selectedAutoFillData?.blueprintVariables?.interviewDuration
      ),
    });
  }, []);

  return (
    <div>
      {selectedAutoFillData?.blueprintVariables && jdDetails && (
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={(errorInfo) => {
            if (errorInfo.errorFields && errorInfo.errorFields.length > 0) {
              const firstError = errorInfo.errorFields[0];
              message.error(firstError.errors[0]); // show first error
            }
          }}
          onValuesChange={(changedValues, allValues) => {
            if ("interviewDuration" in changedValues) {
              setInterviewDuration(changedValues.interviewDuration);
            }
          }}
          initialValues={{
            company: selectedAutoFillData?.blueprintVariables?.company || "",
            jobTitle: selectedAutoFillData?.blueprintVariables?.jobTitle || "",
            yearsOfExperience:
              selectedAutoFillData?.blueprintVariables?.yearsOfExperience || 0,
            userLanguage:
              selectedAutoFillData?.blueprintVariables?.userLanguage
                ?.languageCode || undefined,
            botLanguage:
              selectedAutoFillData?.blueprintVariables?.botLanguage
                ?.languageCode || undefined,
            interviewDuration:
              selectedAutoFillData?.blueprintVariables?.interviewDuration || 30, // default 30 mins
            jobRequirements:
              selectedAutoFillData?.blueprintVariables?.jobRequirements || "",
            jobResponsibilities:
              selectedAutoFillData?.blueprintVariables?.jobResponsibilities ||
              "",
          }}
          className="w-full"
        >
          <div>
            <div className="flex items-end gap-3 justify-between">
              <div>
                <p className="font-semibold text-lg">
                  Job Knowledge Base Configuration
                </p>
                <p className="text-sm text-[#475467]">
                  Key details about the position and its responsibilities.
                </p>
              </div>
              {iDronaConfigFlag ? (
                disableEdit ? (
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setDisableEdit(false);
                    }}
                    className="btn-orange px-3 py-1"
                  >
                    Edit
                  </button>
                ) : (
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setDisableEdit(true);
                    }}
                    className="btn-white px-3 py-1"
                  >
                    Cancel
                  </button>
                )
              ) : null}
            </div>
            <Divider className="my-3 bg-gray-300" />
            <div className="flex gap-5 sm:flex-row flex-col">
              <div className="w-full sm:w-1/2">
                <Form.Item
                  label="Job title"
                  name="jobTitle"
                  className="pb-0 mb-0"
                  rules={[
                    {
                      required: true,
                      message: "Please enter years of experience",
                    },
                  ]}
                >
                  <Input className="w-full" disabled={disableEdit} />
                </Form.Item>
              </div>
              <div className="w-full sm:w-1/2">
                <Form.Item
                  label="Company name"
                  name="company"
                  className="pb-0 mb-0"
                  rules={[
                    {
                      required: true,
                      message: "Please enter years of experience",
                    },
                  ]}
                >
                  <Input className="w-full" disabled={disableEdit} />
                </Form.Item>
              </div>
            </div>
            <div className="flex gap-5 sm:flex-row flex-col mt-4">
              <div className="w-full sm:w-1/2">
                <Form.Item
                  label="Job requirements"
                  name="jobRequirements"
                  className="pb-0 mb-0"
                  rules={[
                    {
                      required: true,
                      message: "Please enter years of experience",
                    },
                  ]}
                >
                  <TextArea
                    placeholder="Type your answer here..."
                    style={{ height: 128, resize: "none" }}
                    className="orange-scroll"
                    disabled={disableEdit}
                  />
                </Form.Item>
              </div>
              <div className="w-full sm:w-1/2">
                <Form.Item
                  label="Job responsibilities"
                  name="jobResponsibilities"
                  className="pb-0 mb-0"
                  rules={[
                    {
                      required: true,
                      message: "Please enter years of experience",
                    },
                  ]}
                >
                  <TextArea
                    placeholder="Type your answer here..."
                    style={{ height: 128, resize: "none" }}
                    className="orange-scroll"
                    disabled={disableEdit}
                  />
                </Form.Item>
              </div>
            </div>
          </div>
          <div className="mt-8">
            <p className="font-semibold text-lg">
              Interview Configuration details
            </p>
            <p className="text-sm text-[#475467]">
              Overview of the interview structure, format, duration and skill
              evaluation.
            </p>
            <Divider className="my-3 bg-gray-300" />
            <div className="flex lg:flex-row flex-col w-full gap-5 mt-4">
              <div className="flex sm:flex-row flex-col lg:w-1/2 w-full  gap-5">
                {/* Years of Experience */}
                <div className="w-full lg:w-1/2">
                  <Form.Item
                    label="Years of Experience"
                    name="yearsOfExperience"
                    className="pb-0 mb-0"
                    rules={[
                      {
                        required: true,
                        message: "Please enter years of experience",
                      },
                    ]}
                  >
                    <InputNumber
                      disabled={disableEdit}
                      min={0}
                      className="w-full"
                    />
                  </Form.Item>
                </div>

                {/* User Language */}
                <div className="w-full lg:w-1/2">
                  <Form.Item
                    label="User Language"
                    name="userLanguage"
                    className="pb-0 mb-0"
                    rules={[
                      {
                        required: true,
                        message: "Please select user language",
                      },
                    ]}
                  >
                    <Select
                      disabled={disableEdit}
                      placeholder="Select user language"
                      className="w-full"
                      optionFilterProp="children"
                    >
                      {jdDetails?.allowedUserLanguages?.map((lang, index) => (
                        <Option key={index} value={lang.languageCode}>
                          {`${lang.language} (${lang.languageCode})`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>
              <div className="flex sm:flex-row flex-col lg:w-1/2 w-full  gap-5">
                {/* Bot Language */}
                <div className="w-full lg:w-1/2">
                  <Form.Item
                    label="Bot Language"
                    name="botLanguage"
                    className="pb-0 mb-0"
                    rules={[
                      { required: true, message: "Please select bot language" },
                    ]}
                  >
                    <Select
                      disabled={disableEdit}
                      placeholder="Select bot language"
                      className="w-full"
                    >
                      {jdDetails?.allowedBotLanguages?.map((lang, index) => (
                        <Option key={index} value={lang.languageCode}>
                          {`${lang.language} (${lang.languageCode})`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>

                {/* Interview Duration */}
                <div className="w-full lg:w-1/2">
                  <Form.Item
                    label={`Interview Dur(${
                      jdDetails?.maxTimeAllowedPerSession / 60
                    }m max. allowed)`}
                    name="interviewDuration"
                    className="pb-0 mb-0"
                    rules={[
                      {
                        required: true,
                        message: "Please enter interview duration",
                      },
                      {
                        validator(_, value) {
                          if (Number(value) >= 0 && Number(value) < 1) {
                            return Promise.reject(
                              "Duration must be at least 1 minute."
                            );
                          }

                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <InputNumber
                      disabled={disableEdit}
                      min={1}
                      max={30}
                      className="w-full"
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
          </div>

          {/* Skill Distribution */}
          <div className="mt-8">
            <div className="flex justify-between gap-3 items-end">
              <div>
                <p className="font-semibold text-lg">Skills distribution</p>
                <p className="text-sm text-[#475467]">
                  Set up key areas for interview evaluation.
                </p>
              </div>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  generateSkills();
                }}
                disabled={disableEdit}
                className={`${
                  disableEdit ? "btn-disabled" : "btn-gold-shine"
                } flex gap-2 items-center px-3 py-[5px]`}
              >
                <svg
                  width="18"
                  height="20"
                  viewBox="0 0 20 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.1877 5.08345C2.24302 5.13415 2.3154 5.16215 2.39043 5.16188C2.46515 5.1617 2.53709 5.1335 2.59203 5.08284C2.64698 5.03219 2.68094 4.96277 2.68722 4.88829C2.7583 4.42559 2.97692 3.99826 3.31051 3.66994C3.64409 3.34163 4.07478 3.12991 4.53842 3.06634C4.60624 3.05292 4.6673 3.01638 4.71119 2.96294C4.75508 2.9095 4.77907 2.84249 4.77907 2.77333C4.77907 2.70417 4.75508 2.63716 4.71119 2.58372C4.6673 2.53029 4.60624 2.49374 4.53842 2.48033C4.07385 2.41912 3.64186 2.20818 3.30784 1.87944C2.97382 1.55069 2.75595 1.12205 2.68722 0.658375C2.6814 0.583387 2.64751 0.513357 2.59233 0.462273C2.53714 0.411189 2.46472 0.382812 2.38953 0.382812C2.31435 0.382812 2.24193 0.411189 2.18674 0.462273C2.13156 0.513357 2.09767 0.583387 2.09185 0.658375C2.02077 1.12107 1.80215 1.5484 1.46856 1.87672C1.13498 2.20504 0.704287 2.41675 0.240653 2.48033C0.172832 2.49374 0.111767 2.53029 0.0678792 2.58372C0.0239911 2.63716 0 2.70417 0 2.77333C0 2.84249 0.0239911 2.9095 0.0678792 2.96294C0.111767 3.01638 0.172832 3.05292 0.240653 3.06634C0.705223 3.12754 1.13721 3.33848 1.47123 3.66723C1.80525 3.99597 2.02312 4.42462 2.09185 4.88829C2.09815 4.96308 2.13237 5.03275 2.1877 5.08345Z"
                    fill="#D0D5DD"
                  />
                  <path
                    d="M8.63353 13.5287C8.56415 13.5289 8.49728 13.503 8.44635 13.4562C8.39542 13.4095 8.36422 13.3453 8.35902 13.2767C8.34365 13.0759 7.92887 8.34422 3.08191 7.25649C3.021 7.24301 2.96653 7.20932 2.92749 7.16099C2.88846 7.11265 2.86719 7.05257 2.86719 6.99063C2.86719 6.92869 2.88846 6.8686 2.92749 6.82026C2.96653 6.77193 3.021 6.73824 3.08191 6.72476C7.93902 5.63512 8.35518 0.75441 8.35874 0.704559C8.36408 0.63596 8.39538 0.571907 8.44635 0.525267C8.49732 0.478626 8.56419 0.452854 8.63353 0.453127C8.70294 0.452938 8.76985 0.478855 8.82079 0.525659C8.87172 0.572463 8.9029 0.636678 8.90803 0.705376C8.9234 0.906141 9.33818 5.63785 14.1851 6.72557C14.2461 6.73906 14.3005 6.77275 14.3396 6.82108C14.3786 6.86941 14.3999 6.9295 14.3999 6.99144C14.3999 7.05338 14.3786 7.11347 14.3396 7.1618C14.3005 7.21014 14.2461 7.24382 14.1851 7.25731C9.32803 8.34694 8.91187 13.2277 8.90831 13.2775C8.9029 13.3461 8.87157 13.41 8.82061 13.4566C8.76965 13.5032 8.70282 13.5289 8.63353 13.5287ZM7.71034 10.1549C8.44635 6.22499 8.35874 7.16099 8.44635 5.35645C8.89352 3.84895 10.2139 5.95622 13.1354 6.9909C10.2325 5.96283 12.2021 6.72476 8.63353 6.225C8.07439 8.25198 8.44635 6.82026 7.71034 10.1549Z"
                    fill="#3b2f1e"
                  />
                  <path
                    d="M2.46066 11.9278C2.53684 12.004 2.64017 12.0468 2.7479 12.0468C2.85564 12.0468 2.95896 12.004 3.03514 11.9278C3.11133 11.8516 3.15412 11.7483 3.15412 11.6405V10.8281C3.15412 10.7204 3.11133 10.617 3.03514 10.5409C2.95896 10.4647 2.85564 10.4219 2.7479 10.4219C2.64017 10.4219 2.53684 10.4647 2.46066 10.5409C2.38448 10.617 2.34168 10.7204 2.34168 10.8281V11.6405C2.34168 11.7483 2.38448 11.8516 2.46066 11.9278Z"
                    fill="#3b2f1e"
                  />
                  <path
                    d="M1.12302 12.8592H1.93546C2.0432 12.8592 2.14652 12.8164 2.2227 12.7402C2.29888 12.664 2.34168 12.5607 2.34168 12.453C2.34168 12.3452 2.29888 12.2419 2.2227 12.1657C2.14652 12.0896 2.0432 12.0468 1.93546 12.0468H1.12302C1.01528 12.0468 0.911957 12.0896 0.835776 12.1657C0.759595 12.2419 0.716797 12.3452 0.716797 12.453C0.716797 12.5607 0.759595 12.664 0.835776 12.7402C0.911957 12.8164 1.01528 12.8592 1.12302 12.8592Z"
                    fill="#3b2f1e"
                  />
                  <path
                    d="M2.46066 14.3651C2.53684 14.4413 2.64017 14.4841 2.7479 14.4841C2.85564 14.4841 2.95896 14.4413 3.03514 14.3651C3.11133 14.2889 3.15412 14.1856 3.15412 14.0779V13.2654C3.15412 13.1577 3.11133 13.0544 3.03514 12.9782C2.95896 12.902 2.85564 12.8592 2.7479 12.8592C2.64017 12.8592 2.53684 12.902 2.46066 12.9782C2.38448 13.0544 2.34168 13.1577 2.34168 13.2654V14.0779C2.34168 14.1856 2.38448 14.2889 2.46066 14.3651Z"
                    fill="#3b2f1e"
                  />
                  <path
                    d="M3.56034 12.8592H4.37279C4.48052 12.8592 4.58385 12.8164 4.66003 12.7402C4.73621 12.664 4.77901 12.5607 4.77901 12.453C4.77901 12.3452 4.73621 12.2419 4.66003 12.1657C4.58385 12.0896 4.48052 12.0468 4.37279 12.0468H3.56034C3.45261 12.0468 3.34928 12.0896 3.2731 12.1657C3.19692 12.2419 3.15412 12.3452 3.15412 12.453C3.15412 12.5607 3.19692 12.664 3.2731 12.7402C3.34928 12.8164 3.45261 12.8592 3.56034 12.8592Z"
                    fill="#3b2f1e"
                  />
                  <path
                    d="M12.1992 11.625L19.1992 19.625"
                    stroke="#3b2f1e"
                    stroke-linecap="round"
                  />
                </svg>
                Use Ai Interview room
              </button>
            </div>
            <Divider className="my-3 bg-gray-300" />
            <div className="mt-4">
              <div>
                {skills.map((skill, skillIndex) => {
                  const totalWeightage = skills.reduce(
                    (acc, s) => acc + (s.skillWeightage || 0),
                    0
                  );

                  const skillDurationMinutes =
                    totalWeightage > 0
                      ? (skill.skillWeightage / totalWeightage) *
                        interviewDuration
                      : 0;

                  // Convert to minutes and seconds
                  const minutes = Math.floor(skillDurationMinutes);
                  const seconds = Math.round(
                    (skillDurationMinutes - minutes) * 60
                  );

                  // Format as "mm:ss"
                  const skillDurationFormatted = `${minutes}m ${seconds}s`;

                  // Avg sub-skill duration
                  const subCount = skill.subSkills?.length || 0;
                  const avgSubSkillMinutes = skillDurationMinutes / subCount;
                  const avgMinutes = Math.floor(avgSubSkillMinutes);
                  const avgSeconds = Math.round(
                    (avgSubSkillMinutes - avgMinutes) * 60
                  );
                  const avgSubSkillDurationFormatted = `${avgMinutes}m ${avgSeconds}s`;

                  return (
                    <div className="flex items-center w-full gap-x-2">
                      <div
                        key={skillIndex}
                        // title={
                        //   <div className="flex items-center gap-x-2">
                        //     <span>Skill {skillIndex + 1}</span>
                        //     {" - "}
                        //     <span className="text-gray-400">
                        //       (duration: {skillDurationFormatted})
                        //     </span>
                        //   </div>
                        // }

                        className="mb-4 relative border-2 lg:flex items-center py-3 px-5 rounded-lg shadow-sm border-gray-300 flex-1"
                      >
                        <div className="flex-1">
                          <div className="flex lg:flex-row flex-col gap-x-8 gap-y-3 items-start">
                            <div className="flex gap-4 flex-wrap mb-2 lg:w-[45%] w-[95%]">
                              <div className="flex-1">
                                <p className="mb-1">
                                  Skill Name -{" "}
                                  <span className="text-gray-400">
                                    (duration: {skillDurationFormatted})
                                  </span>
                                </p>
                                <Input
                                  placeholder="Skill Name"
                                  disabled={disableEdit}
                                  value={skill.skillName}
                                  onChange={(e) =>
                                    updateSkill(
                                      skillIndex,
                                      "skillName",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                              <div className="w-[90px]">
                                <p className="mb-1">Weightage</p>
                                <InputNumber
                                  placeholder="Weightage"
                                  disabled={disableEdit}
                                  min={1}
                                  max={100}
                                  value={skill.skillWeightage}
                                  onChange={(value) =>
                                    updateSkill(
                                      skillIndex,
                                      "skillWeightage",
                                      value
                                    )
                                  }
                                />
                              </div>
                            </div>

                            <div className="lg:w-[55%] w-full">
                              <label className="font-medium">
                                Sub-Skills -{" "}
                                <span className="text-gray-400">
                                  {" "}
                                  (avg. duration: {avgSubSkillDurationFormatted}
                                  ){" "}
                                </span>
                              </label>
                              <div className="flex flex-wrap gap-x-1 gap-y-2 mt-1">
                                {skill?.subSkills.map((sub, subIndex) => (
                                  <Tag
                                    key={subIndex}
                                    disabled={disableEdit}
                                    closable={!disableEdit}
                                    className="py-[5px]"
                                    color="volcano"
                                    onClose={() =>
                                      removeSubSkill(skillIndex, subIndex)
                                    }
                                  >
                                    {sub?.areaOfProbing}
                                  </Tag>
                                ))}
                                {skill?.subSkills?.length < 3 &&
                                  !disableEdit && (
                                    <Input
                                      size="small"
                                      disabled={disableEdit}
                                      className="py-[5px]"
                                      placeholder="+ Add Sub-Skill and press Enter"
                                      style={{ width: 235 }}
                                      value={subInput[skillIndex] || ""} // each skill has its own input
                                      onChange={(e) =>
                                        handleSubInputChange(
                                          skillIndex,
                                          e.target.value
                                        )
                                      }
                                      onPressEnter={(e) => {
                                        e.preventDefault();
                                        handleAddSubSkill(skillIndex);
                                      }}
                                    />
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                        {!disableEdit && (
                          <Trash2
                            disabled={disableEdit}
                            color="#ef4444"
                            onClick={() => {
                              if (disableEdit) return;
                              removeSkill(skillIndex);
                            }}
                            size={22}
                            className={`lg:static absolute top-2 right-2  ${
                              disableEdit
                                ? "cursor-not-allowed"
                                : "cursor-pointer"
                            }`}
                          />
                        )}
                      </div>
                    </div>
                  );
                })}
                <div className="text-center ">
                  {(() => {
                    const totalWeightage = skills.reduce(
                      (acc, skill) => acc + (skill.skillWeightage || 0),
                      0
                    );
                    totalWeightageFinal = totalWeightage;
                    const remaining = 100 - totalWeightage;
                    return (
                      <>
                        <button
                          className={`${
                            totalWeightage > 100 || disableEdit
                              ? "btn-disabled"
                              : "btn-orange"
                          } px-3 py-2`}
                          disabled={totalWeightage > 100 || disableEdit}
                          type="dashed"
                          block
                          onClick={addSkill}
                        >
                          + Add Skill
                        </button>
                        <div className="mb-4 mt-2">
                          <div>
                            {" "}
                            <span className="text-[#667085]">
                              {totalWeightage}% Allocated
                            </span>{" "}
                            |{" "}
                            <span className="text-red-500">
                              {totalWeightage < 100 ? remaining : 0}% Remaining
                            </span>
                          </div>

                          {totalWeightage > 100 && (
                            <p className="text-red-600 font-medium">
                              Total weightage cannot exceed 100!
                            </p>
                          )}
                        </div>
                      </>
                    );
                  })()}
                </div>
              </div>
            </div>
          </div>

          {/* Submit */}
          <div className="mt-6 flex items-center justify-end gap-5">
            {!noBackButton && (
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setSteps(1);
                }}
                className="w-full px-5 py-1 border-2 rounded-md sm:w-auto"
              >
                Back
              </button>
            )}
            {!disableEdit && (
              <>
                {iDronaConfigFlag && (
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setDisableEdit(true);
                    }}
                    className="w-full px-5 py-1 border-2 rounded-md sm:w-auto"
                  >
                    Cancel
                  </button>
                )}
                <button
                  type="primary"
                  htmlType="submit"
                  className="w-full px-5 py-1 btn-orange sm:w-auto"
                >
                  {iDronaConfigFlag ? "Save" : " Save and proceed"}
                </button>
              </>
            )}
          </div>
        </Form>
      )}
    </div>
  );
}

export default SelectedBlueprintForm;
